import styled from '@emotion/styled';

export const TimePickerContainer = styled.div`
    z-index: 1000;
`;

export const TimePickerContent = styled.div`
    max-width: 600px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const TimePickerRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
`;

export const TimePickerLabel = styled.div`
    display: flex;
    align-items: center;
    line-height: 1;
`;
